import { Box } from '@ff-it/ui';
import { usePeriod } from '../usePeriod';
import { Revenue } from './Revenue';
import permissions from './permissions';
import { DatePartPickerField, withHasPerm } from 'components';

export const LocalRevenue = withHasPerm(() => {
  const { date_from: minDate, date_to: maxDate } = usePeriod();
  return (
    <Revenue
      storageKey="reprot_revenue_local"
      global={false}
      url="reporting/revenue/local/"
      filterFields={
        <Box ml="3" mr="4" display="flex" alignItems="center" className="form-group">
          <Box as="label">Compare to:</Box>
          <DatePartPickerField part="year" name="cmp_year" minDate={minDate} maxDate={maxDate} className="ml-2 mb-0" />
        </Box>
      }
    />
  );
}, permissions.local);
